<template>
  <div style="padding: 5px">
    <div style="margin: 10px;display: flex;justify-content: space-between;align-items: center;margin-right: 30px">
      <div style="font-size: 20px">{{ $t('device.addTitle') }}</div>
      <div>
        <a-space>
          <a-button key="submit" type="primary" @click="save">{{ $t('buttons.save') }}</a-button>
          <a-button key="submit" @click="goBack">{{ $t('buttons.goBack') }}</a-button>
        </a-space>
      </div>
    </div>
    <a-divider />
    <div style="position: relative;">
      <a-form-model
        style="width: 100%; display: flex; justify-content: space-between; padding-right: 150px; padding-top: 20px"
        v-bind="{ labelCol: { span: 8 }, wrapperCol: { span: 16 } }" :rules="rules" :model="deviceForm" ref="ruleForm">
        <div style="width: 50%">
          <a-form-model-item :label="$t('common.deviceType')" prop="type">
            <a-select :disabled="title === '编辑设备'" v-model="deviceForm.type">
              <a-select-option v-for="item in deviceTypeList" :key="item.id" :value="item.value"
                @click.native="handleTypeChange(item.value)">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <!-- <a-form-model-item label="设备状态" prop="status">
            <a-select v-model="deviceForm.status">
              <a-select-option v-for="item in deviceStatusList" :key="item.id" :value="item.value">{{ item.text }}</a-select-option>
            </a-select>
          </a-form-model-item>-->
          <a-form-model-item :label="$t('common.deviceCode')" prop="code">
            <a-input :disabled="title === '编辑设备'" v-model="deviceForm.code" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.deviceName')" prop="name">
            <a-input v-model="deviceForm.name" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.deviceAddress')" prop="deviceAddress">
            <a-input v-model="deviceForm.deviceAddress" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.model')" prop="model">
            <a-input v-model="deviceForm.model" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.customer')" prop="customerId">
            <a-select show-search v-model="deviceForm.customerId" :placeholder="$t('placeholder.searchCustomer')"
              :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode" @search="handleSearchCustomer"
              @popupScroll="handlePopupScroll" @blur="handleBlur">
              <a-select-option v-for="d in customerResultList" :key="d.id">{{ d.company }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.protocolCode')" prop="protocolCode" style="position: relative;">
            <a-select show-search v-model="deviceForm.protocolCode" :placeholder="$t('placeholder.searchProtocolCode')"
              :default-active-first-option="false" :show-arrow="false" :filter-option="false" :not-found-content="null"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode" @search="handleSearchProtocol"
              @popupScroll="handleProtocolPopupScroll" @blur="handleBlur" @change="handleChange"
              option-label-prop="label">
              <a-select-option :title="d.code + ' - ' + d.name" v-for="d in protocolList" :key="d.code" :value="d.code"
                :label="d.code">{{ d.code }} - {{ d.name }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.driverType')" prop="driverType">
            <a-select style="width: 100%;" disabled v-model="deviceForm.driverType">
              <a-select-option v-for="drive in driveTypeList" :key="drive.value">{{ drive.text }}</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.intervalTime')" prop="intervalTime">
            <a-select style="width: 100%;" v-model="deviceForm.intervalTime"
              :getPopupContainer="(triggerNode) => triggerNode.parentNode">
              <a-select-option value="10">10</a-select-option>
              <a-select-option value="30">30</a-select-option>
              <a-select-option value="60">60</a-select-option>
              <a-select-option value="180">180</a-select-option>
              <a-select-option value="300">300</a-select-option>
              <a-select-option value="600">600</a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.dtuCode')" prop="dtuCode">
            <a-input v-model="deviceForm.dtuCode" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('device.startTime')" v-if="!isAgent">
            <a-date-picker placeholder="" style="width: 100%" v-model="deviceForm.startTime" />
          </a-form-model-item>
          <a-form-model-item :label="$t('device.bindingDevice')" v-if="!isAgent">
            <div tabindex="-1" class="ant-select ant-select-enabled" data-v-a1ccd506 style="width: 100%;">
              <div @click="showDeviceTableModal" role="combobox" aria-autocomplete="list" aria-haspopup="true"
                aria-controls="50e5fa56-0e69-45c7-d94a-6b44d9a8df95"
                class="ant-select-selection ant-select-selection--multiple">
                <div class="ant-select-selection__rendered">
                  <ul>
                    <li v-for="(s, i) in selectedDeviceList" :key="s.id" @click.stop unselectable="on"
                      role="presentation" title="a1" class="ant-select-selection__choice" style="user-select: none;">
                      <div class="ant-select-selection__choice__content">{{ s.name }}</div>
                      <span class="ant-select-selection__choice__remove">
                        <i @click="handleRemoveSelectedDevice(i)" aria-label="图标: close"
                          class="anticon anticon-close ant-select-remove-icon">
                          <svg viewBox="64 64 896 896" data-icon="close" width="1em" height="1em" fill="currentColor"
                            aria-hidden="true" focusable="false" class>
                            <path
                              d="M563.8 512l262.5-312.9c4.4-5.2.7-13.1-6.1-13.1h-79.8c-4.7 0-9.2 2.1-12.3 5.7L511.6 449.8 295.1 191.7c-3-3.6-7.5-5.7-12.3-5.7H203c-6.8 0-10.5 7.9-6.1 13.1L459.4 512 196.9 824.9A7.95 7.95 0 0 0 203 838h79.8c4.7 0 9.2-2.1 12.3-5.7l216.5-258.1 216.5 258.1c3 3.6 7.5 5.7 12.3 5.7h79.8c6.8 0 10.5-7.9 6.1-13.1L563.8 512z" />
                          </svg>
                        </i>
                      </span>
                    </li>
                    <li class="ant-select-search ant-select-search--inline">
                      <div class="ant-select-search__field__wrap">
                        <input autocomplete="off" value class="ant-select-search__field" />
                        <span class="ant-select-search__field__mirror">&nbsp;</span>
                      </div>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </a-form-model-item>
        </div>
        <div style="width: 50%" class="nLabel">
          <a-form-model-item :label="$t('common.measurement')" prop="measurement">
            <a-input v-model="deviceForm.measurement" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.initialValue')" prop="initialValue">
            <a-input v-model="deviceForm.initialValue" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.remark')">
            <a-input v-model="deviceForm.remark" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.power')">
            <a-input v-model="deviceForm.power" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.pressure')">
            <a-input v-model="deviceForm.pressure" type="text"></a-input>
          </a-form-model-item>
          <!-- <a-form-model-item :label="$t('common.warrantyPeriod')" v-if="!isAgent">
            <a-input v-model="deviceForm.warrantyPeriod" type="text"></a-input>
          </a-form-model-item> -->
          <a-form-model-item :label="$t('common.brand')">
            <a-input v-model="deviceForm.brand" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('common.installAddress')">
            <a-input v-model="deviceForm.installAddress" type="text"></a-input>
          </a-form-model-item>
          <a-form-model-item :label="$t('device.enable')">
            <a-switch :checked-children="$t('device.no')" :un-checked-children="$t('device.yes')"
              v-model="deviceForm.enabled" />
          </a-form-model-item>
          <a-form-model-item :label="$t('common.isStationDevice')" v-if="!isAgent">
            <a-switch :checked-children="$t('common.yes')" :un-checked-children="$t('common.no')"
              v-model="deviceForm.isStationDevice" />
          </a-form-model-item>
          <a-form-model-item :label="$t('device.businessType')" v-if="!isAgent">
            <a-select v-model="deviceForm.businessType">
              <a-select-option v-for="t in businessTypes" :key="t.value">
                {{ t.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
          <a-form-model-item :label="$t('device.endTime')" v-if="!isAgent">
            <a-date-picker placeholder="" style="width: 100%" v-model="deviceForm.endTime" />
          </a-form-model-item>
          <a-form-model-item :label="$t('device.warningTag')">
            <a-select v-model="deviceForm.tag" dropdownClassName="warningTagOption">
              <a-select-option v-for="w in warningTags" :key="w.value">
                {{ w.text }}
              </a-select-option>
            </a-select>
          </a-form-model-item>
        </div>
      </a-form-model>
    </div>
    <a-modal :title="$t('station.ds')" v-model="isDeviceTableVisible" :width="1250" @ok="handleConfirm">
      <a-table row-key="id" :loading="deviceTableLoading" :columns="columns" :data-source="deviceList"
        :pagination="pagination" :row-selection="rowSelection" @change="handlePageChange">
        <template v-slot:code="text">
          <text-highlight :queries="[highLightInfo.code]">
            {{ text }}
          </text-highlight>
        </template>
        <template v-slot:name="text">
          <text-highlight :queries="[highLightInfo.name]">
            {{ text }}
          </text-highlight>
        </template>
        <template v-slot:model="text">
          <text-highlight :queries="[highLightInfo.model]">
            {{ text }}
          </text-highlight>
        </template>
        <template v-slot:company="text">
          <text-highlight :queries="[highLightInfo['customer.company']]">
            {{ text }}
          </text-highlight>
        </template>
        <template v-slot:type="text">
          {{ deviceTypeMap[text] }}
        </template>
        <template v-slot:protocolCode="text">
          <text-highlight :queries="[highLightInfo.protocolCode]">
            {{ text }}
          </text-highlight>
        </template>
        <template v-slot:dtuCode="text">
          <text-highlight :queries="[highLightInfo.dtuCode]">
            {{ text }}
          </text-highlight>
        </template>
        <template v-slot:driverType="text">
          <text-highlight :queries="[highLightInfo.driverType]">
            {{ text }}
          </text-highlight>
        </template>
      </a-table>
    </a-modal>
  </div>
</template>

<script>
import { addDevice, updateDevice, generateDeviceCode, searchDeviceList } from "@/api/device";
import { getDict } from "@/api/dict";
import { searchCustomerList } from "@/api/customer";
import { searchProtocolCode } from "@/api/protocol";
import TextHighlight from "vue-text-highlight";

const queryParams = {
  query: [
    {
      field: "company",
      value: ""
    }
  ],
  filter: [],
  sort: []
};

export default {
  name: "index",
  components: {
    TextHighlight
  },
  created() {
    const a = this.getAuthorities('/equipment/list')
    if (a.find(aa => aa.code === 'device:manage:device:insert' || aa.code === 'device:manage:device:update')) {
      this.isAgent = false
    } else if (a.find(aa => aa.code === 'agent:device:manage:device:insert' || aa.code === 'agent:device:manage:device:update')) {
      this.isAgent = true
    }
    // protocolApi.listAll().then(({ data }) => {
    //   this.protocolList = data
    // }).then(() => {
    //   return deviceApi.getDeviceType()
    // }).then(({ data }) => {
    //   this.deviceTypeList = data
    // }).catch(() => {
    //   // this.$message.error("请求失败")
    // })
    this.deviceMap = {}
  },
  beforeDestroy() {
    this.$store.commit("setDeviceInfo", null);
  },
  data() {
    return {
      title: "添加设备",
      deviceTypeMap: {},
      driveTypeList: [],
      protocolList: [],
      customerResultList: [],
      deviceTypeList: [],
      deviceStatusList: [],
      customerResultList: [],
      deviceList: [],
      deviceForm: {
        code: "",
        name: "",
        type: "",
        status: null,
        deviceAddress: "",
        model: "",
        brand: "",
        customerId: undefined,
        installAddress: "",
        driverType: "",
        protocolCode: "",
        measurement: "",
        dtuCode: "",
        remark: "",
        isStationDevice: true,
        initialValue: "",
        power: "",
        pressure: "",
        warrantyPeriod: null,
        intervalTime: "",
        enabled: true,
        businessType: null,
        startTime: null,
        endTime: null,
        tag: null
      },
      businessTypes: [],
      deviceTableLoading: false,
      timer: null,
      isSelectionShow: false,
      pagination: {
        current: 1,
        pageSize: 10,
        total: 0
      },
      rules: {
        code: [
          {
            required: true,
            message: "请输入设备编号",
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z\d]+$/,
            message: "只能输入大小写字母或数字",
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: "请输入设备名称",
            trigger: "blur"
          }
        ],
        model: [
          {
            required: true,
            message: "请输入规格型号",
            trigger: "blur"
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: "请输入站号地址",
            trigger: "blur"
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        type: [
          {
            required: true,
            message: "请选择设备类型"
          }
        ],
        // status: [
        //   {
        //     required: true,
        //     message: '请选择设备状态'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: "请选择客户"
          }
        ],
        driverType: [
          {
            required: true,
            message: "请选择驱动类型"
          }
        ],
        protocolCode: [
          {
            required: true,
            message: "请选择协议编号",
            trigger: "blur"
          }
        ],
        dtuCode: [
          {
            required: true,
            message: "请输入模块编号"
          }
        ],
        intervalTime: [
          {
            required: true,
            message: '请选择采集间隔'
          }
        ]
      },
      protocolCode: "",
      protocolShow: false,
      page: 1,
      protocolPage: 1,
      currentModule: "device-manage",
      isDeviceTableVisible: false,
      columns: [
        {
          title: () => (
            <div>
              {this.$t('device.code')}
              <a-input v-model={this.queryParams.code} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          dataIndex: 'code',
          key: 'code',
          scopedSlots: {
            customRender: "code"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.deviceName')}
              <a-input v-model={this.queryParams.name} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          width: 120,
          dataIndex: 'name',
          key: 'name',
          scopedSlots: {
            customRender: "name"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.model')}
              <a-input v-model={this.queryParams.model} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          width: 100,
          dataIndex: 'model',
          key: 'model',
          scopedSlots: {
            customRender: "model"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.customer')}
              <a-input v-model={this.queryParams['customer.company']} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          width: 200,
          dataIndex: 'customer.company',
          key: 'customer.company',
          scopedSlots: {
            customRender: "company"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.deviceType')}
              <a-select style="width: 110px" v-model={this.queryParams.type} onChange={this.handleSearch}>
                {
                  this.deviceTypes.map(t => (
                    <a-select-option value={t.value}>
                      {t.text}
                    </a-select-option>
                  ))
                }
              </a-select>
            </div>
          ),
          dataIndex: 'type',
          key: 'type',
          scopedSlots: {
            customRender: "type"
          },
          width: 120
        },
        {
          title: () => (
            <div>
              {this.$t('common.protocolCode')}
              <a-input v-model={this.queryParams.protocolCode} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          dataIndex: 'protocolCode',
          key: 'protocolCode',
          scopedSlots: {
            customRender: "protocolCode"
          },
          width: 180
        },
        {
          title: () => (
            <div>
              {this.$t('common.dtuCode')}
              <a-input v-model={this.queryParams.dtuCode} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          dataIndex: 'dtuCode',
          key: 'dtuCode',
          scopedSlots: {
            customRender: "dtuCode"
          }
        },
        {
          title: () => (
            <div>
              {this.$t('common.driverType')}
              <a-input v-model={this.queryParams.driverType} onKeyup={(e) => e.key === 'Enter' && this.handleSearch()} />
            </div>
          ),
          dataIndex: 'driverType',
          key: 'driverType',
          scopedSlots: {
            customRender: "driverType"
          }
        }
      ],
      queryParams: {
        code: '',
        name: '',
        'customer.company': '',
        type: '',
        model: '',
        protocolCode: '',
        dtuCode: '',
        driverType: ''
      },
      highLightInfo: {
        code: '',
        name: '',
        'customer.company': '',
        type: '',
        model: '',
        protocolCode: '',
        dtuCode: '',
        driverType: ''
      },
      deviceTypes: [],
      rowSelection: {
        selectedRowKeys: [],
        onChange: this.handleRowChange
      },
      selectedDeviceList: [],
      isAgent: false,
      warningTags: []
    };
  },
  computed: {
    paramList() {
      return this.protocolList.filter(
        item =>
          item.protocolCode.includes(this.protocolCode) ||
          item.protocolName.includes(this.protocolCode)
      );
    },
    lang() {
      return this.$store.state.lang
    }
  },
  watch: {
    lang: {
      immediate: true,
      handler() {
        this.translate()
      }
    }
  },
  methods: {
    translate() {
      this.rules = {
        code: [
          {
            required: true,
            message: this.$t('messages.pedc'),
            trigger: "blur"
          },
          {
            pattern: /^[a-zA-Z\d]+$/,
            message: this.$t('messages.lon'),
            trigger: "blur"
          }
        ],
        name: [
          {
            required: true,
            message: this.$t('messages.pedn'),
            trigger: "blur"
          }
        ],
        model: [
          {
            required: true,
            message: this.$t('messages.pedm'),
            trigger: "blur"
          }
        ],
        deviceAddress: [
          {
            required: true,
            message: this.$t('messages.peda'),
            trigger: "blur"
          }
          // {
          //   min: 2,
          //   max: 2,
          //   message: '站号地址必须为2位',
          //   trigger: 'blur'
          // },
          // {
          //   validator(rule, value, callback) {
          //     if (value === '16') {
          //       return callback('请输入正确的16进制地址')
          //     }
          //     const reg = new RegExp(/^[0-9a-f]+$/i)
          //     if(reg.test(value)) {
          //       callback()
          //     } else {
          //       callback(reg.test(value))
          //     }
          //   },
          //   message: '请输入正确的16进制地址',
          //   trigger: 'blur'
          // }
        ],
        type: [
          {
            required: true,
            message: this.$t('messages.pedt')
          }
        ],
        // status: [
        //   {
        //     required: true,
        //     message: '请选择设备状态'
        //   }
        // ],
        customerId: [
          {
            required: true,
            message: this.$t('messages.pec')
          }
        ],
        driverType: [
          {
            required: true,
            message: this.$t('messages.pedd')
          }
        ],
        protocolCode: [
          {
            required: true,
            message: this.$t('messages.pedp'),
            trigger: "blur"
          }
        ],
        dtuCode: [
          {
            required: true,
            message: this.$t('messages.pedtu')
          }
        ],
        intervalTime: [
          {
            required: true,
            message: this.$t('messages.psi')
          }
        ]
      }
      const lang = this.lang === 'en' ? 'en-US' : 'zh-CN'
      getDict(lang, "deviceType").then(({ data }) => {
        this.deviceTypeList = data.content.map(c => {
          this.deviceTypeMap[c.value] = c.text;
          return c;
        });
        this.deviceTypes = data.content
        this.deviceTypes.unshift({
          text: this.$t('common.all'),
          value: ''
        })
      });
      getDict(lang, "deviceStatus").then(({ data }) => {
        this.deviceStatusList = data.content;
      });
      getDict(lang, "driverType").then(({ data }) => {
        this.driveTypeList = data.content;
      });
      getDict(lang, 'deviceBusinessType').then(({ data }) => {
        this.businessTypes = data.content
      })
      getDict(lang, 'warningTag').then(({ data }) => {
        this.warningTags = data.content
      })
    },
    selectCustomer(value) {
      this.deviceForm.customerId = value.id;
      this.deviceForm.companyName = value.companyName;
      this.selected = true;
    },
    selectProtocol(value) {
      const res = this.protocolList.find(item => item.protocolCode === value);
      console.log(res);
      this.deviceForm.driverType = res.driverType;
      this.deviceForm.intervalTime = res.intervalTime + "";
    },
    async handleTypeChange(value) {
      if (value === "LGJ") {
        this.deviceForm.code = "";
        return;
      }
      try {
        const { data } = await generateDeviceCode({ deviceType: value });
        this.deviceForm.code = data;
      } catch (e) {
        console.log(e);
      }
    },
    goBack() {
      this.$store.commit("setDeviceFlag", true);
      this.$router.back();
    },
    save() {
      // this.deviceForm.initialValue = +this.deviceForm.initialValue

      this.$refs.ruleForm.validate(valid => {
        if (valid) {
          const deviceForm = { ...this.deviceForm }
          deviceForm.startTime = this.deviceForm.startTime ? this.deviceForm.startTime._d.getTime() : null
          deviceForm.endTime = this.deviceForm.endTime ? this.deviceForm.endTime._d.getTime() : null
          deviceForm.bindingDevices = this.selectedDeviceList.map(s => ({ id: s.id }))
          deviceForm.deviceAddress = deviceForm.deviceAddress.length < 2 ? "0" + deviceForm.deviceAddress : deviceForm.deviceAddress
          addDevice(deviceForm)
            .then(({ message }) => {
              this.$message.success(message);
            })
            .catch(({ message }) => {
              this.$message.warn(message);
            });
        }
      });
    },
    /*  */
    debounce(f, delay, ...args) {
      if (this.timer) {
        clearTimeout(this.timer);
      }
      this.timer = setTimeout(() => {
        f(...args);
        this.timer = null;
      }, delay);
    },
    async handlePopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.page++;
        const { data } = await searchCustomerList(this.page, 10, queryParams);
        this.customerResultList = this.customerResultList.concat(data.records);
      }
    },
    async handleProtocolPopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.protocolPage++;
        const { data } = await searchProtocolCode(
          this.protocolPage,
          10,
          this.value,
          this.value
        );
        this.protocolList = this.protocolList.concat(data.records);
      }
    },
    handleSearchCustomer(value) {
      this.debounce(async () => {
        try {
          queryParams.query[0].value = value;
          const { data } = await searchCustomerList(this.page, 10, queryParams);
          this.customerResultList = data.records;
          this.page = 1;
        } catch (e) {
          console.log(e);
        }
      }, 300);
    },
    handleSearchProtocol(value) {
      this.value = value;
      this.debounce(async () => {
        try {
          const { data } = await searchProtocolCode(
            this.protocolPage,
            10,
            this.value,
            this.value
          );
          this.protocolList = data.records;
          this.protocolPage = 1;
        } catch (e) {
          console.log(e);
        }
      }, 300);
    },
    async handleProtocolPopupScroll(e) {
      const { scrollHeight, scrollTop, clientHeight } = e.target;
      if (scrollHeight - scrollTop === clientHeight) {
        this.protocolPage++;
        const { data } = await searchProtocolCode(
          this.protocolPage,
          10,
          this.value,
          this.value
        );
        this.protocolList = this.protocolList.concat(data.records);
      }
    },
    handleBlur() {
      this.page = 1;
      this.protocolPage = 1;
      this.protocolList = [];
      this.userList = [];
      this.$forceUpdate();
    },
    handleChange(value) {
      const p = this.protocolList.find(p => p.code === value);
      this.deviceForm.driverType = p.driver;
      this.deviceForm.intervalTime = p.intervalTime;
    },
    search(e) {
      if (e.target.value.trim() === "") {
        this.isSelectionShow = false;
      } else {
        this.debounce(this.searchCustomer, 500, e.target.value);
      }
    },
    handleFocus(e) {
      this.selected = false;
      if (e.target.value.trim() === "") {
        this.customerResultList = [];
      } else {
        this.isSelectionShow = true;
      }
    },
    handleBlur() {
      this.page = 1;
      this.protocolPage = 1;
      this.protocolList = [];
      this.userList = [];
      this.$forceUpdate();
    },
    selecteProtocol(item) {
      this.protocolCode = this.deviceForm.protocolCode = item.protocolCode;
      this.deviceForm.driverType = item.driverType;
    },
    showDeviceTableModal() {
      this.isDeviceTableVisible = true
      // if (!this.deviceList?.length) {
      //   this.getDeviceList()
      // }
      this.rowSelection.selectedRowKeys = this.selectedDeviceList.map(s => s.id)
    },
    async getDeviceList() {
      try {
        this.deviceTableLoading = true
        const queryParams = {
          query: [],
          sort: [
            {
              field: 'updatedAt',
              value: 'DESC'
            }
          ],
          filter: []
        }
        for (let key in this.queryParams) {
          queryParams.query.push({
            field: key,
            value: this.queryParams[key]
          })
        }
        const { data } = await searchDeviceList(this.pagination.current, this.pagination.pageSize, queryParams)
        this.deviceList = data.records
        this.pagination.current = data.current
        this.pagination.total = data.total
        for (let key in this.queryParams) {
          this.highLightInfo[key] = this.queryParams[key]
        }
      } catch (e) {
        console.log(e)
      } finally {
        this.deviceTableLoading = false
      }
    },
    handlePageChange(page) {
      this.pagination = page
      this.getDeviceList()
    },
    handleSearch() {
      this.pagination.current = 1
      this.getDeviceList()
    },
    handleRowChange(selectedRowKeys, selectedRows) {
      selectedRows.forEach(s => {
        this.deviceMap[s.id] = s
      })
      this.rowSelection.selectedRowKeys = selectedRowKeys
    },
    handleConfirm() {
      this.selectedDeviceList = this.rowSelection.selectedRowKeys.map(i => this.deviceMap[i])
      this.isDeviceTableVisible = false
    },
    handleRemoveSelectedDevice(i) {
      this.selectedDeviceList.splice(i, 1)
      this.rowSelection.selectedRowKeys = this.selectedDeviceList.map(s => s.id)
    }
  }
};
</script>

<style lang="less" scoped>
li {
  list-style: none;
}

ul {
  padding: 0;
  margin: 0;
}

.row {
  margin-top: 5px;
}

.selection {
  width: 570px;
  max-height: 260px;
  position: absolute;
  top: 293px;
  left: 570px;
  list-style: none;
  margin: 0;
  padding: 0;
  border: 1px solid #ccc;
  border-radius: 5px 0 0 5px;
  /* overflow-y: auto; */
  background-color: #fff;
  z-index: 10;
}

.selection h4 {
  font-size: 16px;
  color: #999;
  line-height: 1;
  padding: 10px 10px 0;
}

.selection li {
  cursor: pointer;
  padding: 8px 10px;
}

li.companyName:hover {
  background-color: #eee;
}
</style>
